import styles from "./AuthorSection.module.css";
import { AuthorBlock } from "@/types/author";
import { CmsImage } from "@/components/common/CmsImage";

const AuthorSection = ({ authorBlock }: { authorBlock: AuthorBlock }) => {
    const author = authorBlock.author;
    return (
        <div className={styles.contentParentOuter}>
            <div className={styles.contentContainer}>
                <div className={styles.imageContainer}>
                    {author?.data?.attributes?.profilePicture ? (
                        <CmsImage
                            cmsMedia={author.data?.attributes.profilePicture}
                            maxWidth={130}
                            responsive={false}
                            desiredHeight={130}
                        />
                    ) : null}
                </div>
                <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{
                        __html:
                            author?.data?.attributes
                                ?.sanitisedAuthorDescription || "",
                    }}
                />
            </div>
        </div>
    );
};

export default AuthorSection;
